// src/data/programAudience.js

const programAudience = [
    {
      slug: "digital-marketing-mentorship-program",
      heading: "Still wondering If Digital Marketing Mentorship Program is for you?",
      description: "First of all, this Paid Marketing Program is not just for job seekers; it also caters to digital marketing enthusiasts, product managers, growth managers and performance marketers",
      suitableFor: [
        "Professionals",
        "Freelancers",
        "Product Managers",
        "Entrepreneurs",
        "Founders",
        "Growth managers"
      ]
    },
    {
      slug: "performance-marketing-mentorship-program",
      heading: "Still wondering If Performance Marketing Mentorship Program is for you?",
      description: "First of all, the Performance Marketing Mentorship Program is not just for job seekers; it also caters to mid-level digital marketing and performance marketing professionals, working professionals in data, analytics, web, UX, and product, digital marketers, marketing freelancers, founders/marketing agency owners, and social media marketers.",
      suitableFor: [
        "Professionals",
        "Freelancers",
        "Entrepreneurs",
        "Brand Managers",
        "Sales Professional",
          "Freelancers",
          "Ecommerce Managers",
        "Digital Marketers"
      ]
    },
    {
      slug: "ui-ux-design-mentorship-program",
      heading: "Still wondering If UI/UX Design Mentorship Program is for you?",
      description: "The UX Design Mentorship Program is tailored not only for job seekers but also for a wide array of participants, including design students, graphic designers, individuals transitioning to UX design, self-taught designers, freelancers, and UI/UX designers looking to build or enhance their portfolios.",
      suitableFor: [
        "Professionals",
        "Freelancers",
        "Graphic Designers",
        "Design Students",
        "Self-Taught Designers",
        "Designers Wanting to Build a Portfolio"
      ]
    },
    {
      slug: "product-management-mentorship-program",
      heading: "Still wondering If Product Management Mentorship Program is for you?",
      description: "The Product Management Program is designed not only for job seekers but also for a diverse audience including students, graduates, entrepreneurs, and aspiring product managers, catering to a broad range of professional aspirations and educational backgrounds.",
      suitableFor: [
        "Freelancers",
        "Student",
        "Product Managers",
        "Entrepreneurs",
       
      ]
    },
    {
      slug: "management-consulting-mentorship-program",
      heading: "Still wondering If Management Consulting Mentorship Program is for you?",
      description: "Gain a thorough understanding of the consulting industry, its diverse career trajectories, necessary skills, and the inner workings of consulting firms. This knowledge will empower you to make well-informed decisions about your potential engagement in this field.",
      suitableFor: [
        "Aspiring Strategy Consultants",
        "Early-tenure Management Consultants",
        "Job Seekers",
        "Marketers & Growth Managers",
        "Business Students",
        "Anyone curious about what consultants & consulting firms truly do"
      ]
  },
      {
      slug: "product-marketing-mentorship-program",
      heading: "Still wondering If Product Marketing Program is for you?",
      description: "First of all, the Product Marketing Program is not just for job seekers; it also caters to brand marketers, performance marketers, digital marketers and aspiring DMs, founders or management leaders, current product marketers, and students.",
      suitableFor: [
        "Brand Marketers",
        "Performance Marketers",
        "Students",
        "Current Product Marketers",
        "Founders",

      ]
  },
       {
      slug: "workshops/business-mastermind",
      heading: "Still wondering If this Mastermind is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Entrepreneurs",
        "Founders",
        "Senior Managers",
        "Leaders",
        "Tech-Curious Professionals",
        "Consultants & Specialists"

      ]
  },
            {
      slug: "workshops/marketing-mastermind",
      heading: "Still wondering If this Mastermind is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Entrepreneurs",
        "Founders",
        "Senior Managers",
        "Leaders",
        "Tech-Curious Professionals",
        "Consultants & Specialists"
      ]
  },
                    {
      slug: "workshops/product-management",
      heading: "Still wondering If this Product Management Workshop is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Aspiring Product Managers",
        "Early-Career Product Managers",
        "Startup Founders and Entrepreneurs",
        "Business and Marketing Professionals",
        "Project Managers and Team Leaders",
        "Corporate Executives",
         "Students and Recent Graduates",
        "Tech Enthusiasts",
        "Anyone interested in learning product management"
      ]
  },
                                    {
      slug: "workshops/ai-for-consultants",
      heading: "Still wondering If this Consulting Workshop is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Consultants Across Domains",
        "Aspiring Consultants",
        "Business Owners",
        "Founders/ Entrepreneurs",
        "Corporate Executives",
        "Freelance Consultants",
         "Business Analysts",
        "Students"
       
      ]
  },
                                                                        {
      slug: "workshops/linkedin-growth",
      heading: "Still wondering If this Consulting Workshop is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Consultants Across Domains",
        "Aspiring Consultants",
        "Business Owners",
        "Founders/ Entrepreneurs",
        "Corporate Executives",
        "Freelance Consultants",
         "Business Analysts",
        "Students"
       
      ]
         },
         {
      slug: "workshops/chatgpt-workshop",
      heading: "Still wondering If this Consulting Workshop is for you?",
      description: "Whether you're just starting out, climbing the ladder, or leading the way, this workshop is designed for ambitious business professionals:",
      suitableFor: [
        "Consultants Across Domains",
        "Aspiring Consultants",
        "Business Owners",
        "Founders/ Entrepreneurs",
        "Corporate Executives",
        "Freelance Consultants",
         "Business Analysts",
        "Students"
       
      ]
    }
  ];
  
  export default programAudience;